// extracted by mini-css-extract-plugin
export default {"wrapper":"I6-z","play":"J6-z"};